import './SlideContent.css'

interface Props {
    type: "segment" | "navbar",
    class?: any
}

const SlideContent: React.FC<Props> = (props) => {
    var classNames = ["slide-content"];
    if (props.type == "segment") {
        classNames.push("with-segment");
    } else if (props.type == "navbar") {
        classNames.push("with-navbar");
    }

    if (props.class) {
        classNames.push(props.class);
    }

    return <div className={classNames.join(" ").toString()}>
        {props.children}
    </div>
}

export default SlideContent